/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type InboxThreadListItemDraftStatus = typeof InboxThreadListItemDraftStatus[keyof typeof InboxThreadListItemDraftStatus] | null;


export const InboxThreadListItemDraftStatus = {
  generating: 'generating',
  ready: 'ready',
  accepted: 'accepted',
  denied: 'denied',
  failed: 'failed',
} as const;
